module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "width": _vm.isMobileSize ? '90%' : '40%',
      "persistent": ""
    },
    model: {
      value: (_vm.mostrarModal),
      callback: function($$v) {
        _vm.mostrarModal = $$v
      },
      expression: "mostrarModal"
    }
  }, [_c('v-card', {
    staticClass: "popup-modal"
  }, [(_vm.tipo == 'preMatricula') ? _c('v-container', [_c('h3', {
    staticClass: "pb-3",
    class: {
      'display-0': _vm.isMobileSize, 'display-1': !_vm.isMobileSize
    }
  }, [_vm._v("\n                    Pré-matriculado\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    class: {
      'body-1': _vm.isMobileSize, 'subheading': !_vm.isMobileSize
    }
  }, [_vm._v("\n                        Olá "), _c('strong', [_vm._v(_vm._s(_vm.primeiroNome))]), _vm._v(", sua situação acadêmica ainda consta como\n                        pré-matriculado. Para confirmar sua matrícula, efetive o pagamento do 1º boleto.\n                        "), (_vm.primeiroTitulo) ? [_c('imprimir-boleto', {
    staticClass: "d-inline-block",
    attrs: {
      "titulo": _vm.primeiroTitulo,
      "descricao-link": "Clique aqui para imprimir o boleto"
    }
  }), _vm._v(".\n                        ")] : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                        * Caso já tenha efetuado o pagamento, o mesmo pode levar até três dias úteis para\n                        confirmação.\n                        Se ainda\n                        assim persistir a mensagem, entre em contato com a Central de Atendimento para maiores\n                        informações.\n                    ")], 2)])]) : _vm._e(), _vm._v(" "), (_vm.tipo == 'intencaoMatricula') ? _c('v-container', [_c('h3', {
    staticClass: "pb-3",
    class: {
      'display-0': _vm.isMobileSize, 'display-1': !_vm.isMobileSize
    }
  }, [_vm._v("\n                    Intenção de Matrícula\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    class: {
      'body-1': _vm.isMobileSize, 'subheading': !_vm.isMobileSize
    }
  }, [_vm._v("\n                        Olá "), _c('strong', [_vm._v(_vm._s(_vm.primeiroNome))]), _vm._v(", sua situação acadêmica ainda consta como\n                        pré-matriculado em curso com intenção de matrícula. Para confirmar seu interesse, efetive o pagamento do boleto.\n                        "), (_vm.primeiroTitulo) ? [_c('imprimir-boleto', {
    staticClass: "d-inline-block",
    attrs: {
      "titulo": _vm.primeiroTitulo,
      "descricao-link": "Clique aqui para imprimir o boleto"
    }
  }), _vm._v(".\n                        ")] : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                        * Caso já tenha efetuado o pagamento, o mesmo pode levar até três dias úteis para\n                        confirmação.\n                        Se ainda\n                        assim persistir a mensagem, entre em contato com a Central de Atendimento para maiores\n                        informações.\n                    ")], 2)])]) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModal = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1670c9a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/dashboard/popup/PreMatriculadoPopup.vue
// module id = 526
// module chunks = 2